export default "__VITE_ASSET__BGz$FnFD__"